import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import Router from "./app/Router";
import { store, persistor } from "./app/store";
import { PersistGate } from "redux-persist/integration/react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { initializeApp } from "firebase/app";
import { getPerformance } from "firebase/performance";

const firebaseConfig = {
  apiKey: "AIzaSyA4KYyMVmDuDTFq_eEmuSL99SnItWgH4jU",
  authDomain: "dealmachine-ed724.firebaseapp.com",
  databaseURL: "https://dealmachine-ed724.firebaseio.com",
  projectId: "dealmachine-ed724",
  storageBucket: "dealmachine-ed724.firebasestorage.app",
  messagingSenderId: "81024286635",
  appId: "1:81024286635:web:4a3bc8fccf246275d15cee",
  measurementId: "G-0F6H7X434C"
};

// deploy I
ReactDOM.render(
  <GoogleOAuthProvider clientId="28374041577-or3671jh7838hi1mn3ilb90mpn7qglnf.apps.googleusercontent.com">
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router />
      </PersistGate>
    </Provider>
  </GoogleOAuthProvider>,
  document.getElementById("root")
);

const app = initializeApp(firebaseConfig);
const performance = getPerformance(app);
